












import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class extends Vue {
    mounted() { 
        this.$store.dispatch("load");
    }

    get version(): string {
        return this.$store.getters.version;
    }
}
